<template>
  <a-dropdown :trigger="['click']" placement="bottomLeft">
    <div :class="$style.dropdown">
      <strong class="text-uppercase">{{ $t('flag') }} {{ currentLanguage }}</strong>
    </div>
    <a-menu slot="overlay" @click="menuClick">
      <a-menu-item key="en">
        <span role="img" aria-label="English" class="mr-2">🇺🇸</span>
        English
      </a-menu-item>
      <a-menu-item key="vi">
        <span role="img" aria-label="French" class="mr-2">🇻🇳</span>
        Tiếng Việt
      </a-menu-item>
    </a-menu>
  </a-dropdown>
</template>

<style lang="scss" module>
@import "./style.module.scss";
</style>
<script>
export default {
  data() {
    return {
      currentLanguage: this.$i18n.locale,
    }
  },
  methods: {
    menuClick(e) {
      window.localStorage.setItem('language', this.currentLanguage = this.$i18n.locale = e.key)
    },
  },
}
</script>
